module.exports = __webpack_public_path__ + "img/16.6ad1d03e.png";